// @flow
import React, { Component } from "react";
import CloseIcon from "react-feather/dist/icons/x";
import "rc-slider/assets/index.css";
import styles from "./SubscribeModal.module.css";

type State = {};

class SubscribeModal extends Component<Props, State> {
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.close();
    }
  };

  render() {
    const { close, isSubscribeModalOpen } = this.props;
    if (!isSubscribeModalOpen) return null;

    return (
      <div
        className={styles.FilterBarModal}
        style={{
          right: 0,
          top: 40,
          width: 600
        }}
      >
        <button
          className={styles.CloseIconButton}
          onClick={close}
          type="button"
        >
          <CloseIcon size={20} />
        </button>
        <form
          action="https://templarbit.us16.list-manage.com/subscribe/post?u=aeea35e3b53d5a6051f1459b7&amp;id=fa37b0bd35"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className={styles.subscribeForm}
          noValidate
        >
          <div
            className={styles.FilterBarModalContent}
            style={{
              height: 200
            }}
          >
            <div className={styles.severityContainer}>
              <h3 className={styles.subscribeLabel}>
                <a>SUBSCRIBE TO BREACHROOM</a>
              </h3>
              <h5 className={styles.subscribeLabelSub}>
                <a>Get Notified when new data breaches happen</a>
              </h5>
            </div>
            <div id="mc_embed_signup_scroll">
              <div className={styles.subscribeFiledGroup}>
                <input
                  type="email"
                  name="EMAIL"
                  placeholder="Email Address"
                  className={styles.subscribeText}
                  id="mce-EMAIL"
                />
              </div>
              <div
                style={{
                  position: "absolute",
                  left: -5000
                }}
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_aeea35e3b53d5a6051f1459b7_fa37b0bd35"
                  tabIndex="-1"
                  value=""
                />
              </div>
            </div>
          </div>
          <div className={styles.modalFooter}>
            <button
              className={styles.buttonClearAll}
              onClick={close}
              type="button"
            >
              Cancel
            </button>
            <input
              type="submit"
              value="Subscribe"
              className={styles.buttonPrimary}
              id="mc-embedded-subscribe"
            />
          </div>
        </form>
      </div>
    );
  }
}

export default SubscribeModal;



// WEBPACK FOOTER //
// ./src/components/shared/SubscribeModal/SubscribeModal.js